import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { ObservableRequestService } from 'app/services/observable-request.service';

import { plainToClass } from 'class-transformer';
import { SurveyInstance } from 'app/shared/models/survey/survey-instance';
import { EntityType } from 'app/shared/models/entity-id-details.model';

/**
 * Service for Transaction Profile Descriptions.
 */
@Injectable()
export class TransactionProfileDescService {

    constructor(private requestService: ObservableRequestService) { }

    // Get Transaction Profile Details.
    getTransactionProfileDesc(entityId: number): Observable<any> {
        const transactionProfileDescUri = `${ConstantsService.SURVEY_DETAILS}/${entityId}/details`;
        return this.requestService.getRequest(transactionProfileDescUri).map(response => {
            return plainToClass(SurveyInstance, response.arrResult as Object[]);
        });
    };
}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/transactionprofiledesc/transaction-profile-desc.service.ts